<template>
    <div class="">
        <div v-if="fabricator_id === 8 && !mdd" class="hallmark-designer-price-box">
            <div class="hallmark-designer-price-box-trade-price">
                <strong>Trade Price</strong>
                Save up to 49%
            </div>
            <div class="hallmark-designer-price-box-price">
                <h4>Your Price</h4>
                <strong v-if="priceIsPending" class="txt-light">&pound;---.--</strong>
                <strong v-if="has_breakdown && canHaveBreakdown && !priceIsPending" data-designer-help-text="Show Price Breakdown"><a @click.stop.prevent="show_breakdown_modal" href="#">{{ formatted_price }}</a></strong>
                <strong v-if="(!has_breakdown || !canHaveBreakdown) && !priceIsPending && !hasResellerBreakdown">{{ formatted_price }}</strong>
            </div>
        </div>
        <template v-else>
            <strong v-if="priceIsPending" class="txt-light">&pound;---.--</strong>
            <strong v-if="has_breakdown && canHaveBreakdown && !priceIsPending" data-designer-help-text="Show Price Breakdown"><a @click.stop.prevent="show_breakdown_modal" href="#">{{ formatted_price }}</a></strong>
            <strong v-if="(!has_breakdown || !canHaveBreakdown) && !priceIsPending && !hasResellerBreakdown">{{ formatted_price }}</strong>
        </template>
      <div class="flex justify-center" v-if="(!has_breakdown || !canHaveBreakdown) && !priceIsPending && hasResellerBreakdown" data-modal-show="#customer_breakdown_modal">
        <strong>
          {{ formatted_price }}
        </strong>
          <div class="txt-sm flex flex-col justify-around">
            <i class="fa fa-question-circle"></i>
          </div>
      </div>
        <div :id="'breakdown'" v-show="false">
            <table class="table _slim" v-if="has_breakdown && canHaveBreakdown">
                <thead>
                <tr>
                    <th colspan="2">Description</th>
                    <th v-if="has_sales_codes">Sales Code</th>
                    <th class="align-right" v-if="show_discount && !has_sales_codes">List</th>
                    <th class="align-right" v-if="show_discount">Discount</th>
                    <th class="align-right">Net</th>
                    <th class="align-right" v-if="inScope('cost-prices')">Cost</th>
                    <th class="align-right" v-if="inScope('cost-prices')">Profit</th>
                    <th class="align-right" v-if="inScope('cost-prices')">&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in filtered_breakdown">
                    <td class="align-left" v-html="getDescription(row)"></td>
                    <td v-if="!row.fabricator_list_price">-</td>
                    <td v-if="!row.fabricator_list_price && has_sales_codes">-</td>
                    <td v-if="!row.fabricator_list_price && show_discount && !has_sales_codes">-</td>
                    <td class="align-left" v-if="row.fabricator_list_price">{{ row.fabricator_list_price.priceable.name }}</td>
                    <td v-if="has_sales_codes && row.fabricator_list_price && row.fabricator_list_price.sales_code !== null">{{ row.fabricator_list_price.sales_code.sales_code }}</td>
                    <td v-if="has_sales_codes && row.fabricator_list_price && row.fabricator_list_price.sales_code === null"> - </td>
                    <td class="align-right" v-if="row.fabricator_list_price && show_discount && !has_sales_codes">{{ format_price(row.fabricator_list_price.value, this.currency()) }} ({{ row.fabricator_list_price.unit_of_measurement }})</td>
                    <td class="align-right" v-if="show_discount && row.discount_customer !== null && row.discount_customer.value_type === 'Fixed'">={{ format_price(row.discount_customer.value_amount, this.currency()) }}</td>
                    <th class="align-right" v-if="show_discount && row.discount_customer !== null && row.discount_customer.value_type === 'Fixed'">{{ format_price(row.price, this.currency()) }}</th>

                    <td class="align-right" v-if="show_discount && row.discount_customer !== null && row.discount_customer.value_type === 'Deduct'">={{ format_price(row.discount_customer.value_amount, this.currency()) }}</td>
                    <th class="align-right" v-if="show_discount && row.discount_customer !== null && row.discount_customer.value_type === 'Deduct'">{{ format_price(row.price, this.currency()) }}</th>

                    <td class="align-right" v-if="show_discount && row.discount_customer !== null && row.discount_customer.value_type === 'Percent'">-{{ row.discount_customer.value_amount }}%</td>
                    <th class="align-right" v-if="show_discount && row.discount_customer !== null && row.discount_customer.value_type === 'Percent'">{{ format_price(row.price, this.currency()) }}</th>
                    <td class="align-right" v-if="show_discount && row.discount_customer === null">-</td>
                    <th class="align-right" v-if="!show_discount || row.discount_customer === null">{{ format_price(row.price, this.currency())}}</th>
                    <th class="align-right" v-if="inScope('cost-prices')">{{ format_price(row.cost, this.currency())}}</th>
                    <th class="align-right" v-if="inScope('cost-prices')">{{ format_price((row.price - row.cost), this.currency()) }}</th>
                    <th class="align-right" v-if="inScope('cost-prices')">&nbsp;</th>
                </tr>
                <tr v-if="inScope('cost-prices')">
                    <th colspan="2"></th>
                    <th v-if="has_sales_codes"></th>
                    <th class="align-right" v-if="show_discount && !has_sales_codes"></th>
                    <th class="align-right" v-if="show_discount"></th>
                    <th class="align-right">Total Net</th>
                    <th class="align-right">Total Cost</th>
                    <th class="align-right">Total Profit</th>
                    <th class="align-right">Total Margin</th>
                </tr>
                <tr v-if="inScope('cost-prices')">
                    <th colspan="2"></th>
                    <th v-if="has_sales_codes"></th>
                    <th class="align-right" v-if="show_discount && !has_sales_codes"></th>
                    <th class="align-right" v-if="show_discount"></th>
                    <th class="align-right">{{ formatted_price }}</th>
                    <th class="align-right">{{ formatted_total_cost }}</th>
                    <th class="align-right">{{ formatted_total_profit }}</th>
                    <th class="align-right">{{ formatted_total_margin }}</th>
                </tr>
                </tbody>
            </table>
        </div>

    </div>

    <div class="modal-window" id="customer_breakdown_modal" tabindex="-1" role="dialog" v-if="hasResellerBreakdown">
        <div class="modal-window-inner" role="document">
            <div class="modal-header">
                <button type="button" class="close" data-modal-hide aria-label="Close"><i class="far fa-times"></i></button>
                <h4 class="modal-title">Price Breakdown</h4>
            </div>
            <div class="modal-content">
                <table class="table _slim">
                    <tr v-for="(value, label) in reseller_breakdown" v-show="value > 0">
                        <td :class="{ 'txt-strong' : label === 'Total' }">
                            {{ label }}
                        </td>
                        <td class="align-right" :class="{ 'txt-strong' : label === 'Total' }">
                            {{ format_price(value, currency()) }}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>

</template>

<script type="text/ecmascript-6">
    import {featureInScope} from "../composables/FeatureInScope.js";
    import Currency from "./mixin/Currency.vue";

    export default {
        setup() {
            const {inScope} = featureInScope();
            return {inScope};
        },
        mixins: [
            Currency,
        ],
        props: {
            canHaveBreakdown: {
                default() {
                    return false;
                }
            },
            mdd: {
                default() {
                    return false;
                }
            },
            show_discount: {
              default() {
                return false;
              }
            },
            isProcessor: {
                default() {
                    return false;
                }
            },
        },
        computed: {
            priceIsPending() {
                return this.loading || this.current_request_count > 0;
            },
            has_breakdown(){
                for(var prop in this.breakdown) {
                    if (this.breakdown.hasOwnProperty(prop)) {
                        return true;
                    }
                }

                return false;
            },
            formatted_price(){
                return this.format_price(this.price, this.currency());
            },
            formatted_total_cost(){
                return this.format_price(this.cost, this.currency());
            },
            formatted_total_profit(){
                return this.format_price((this.price - this.cost), this.currency());
            },
            formatted_total_margin(){
              var margin = 0;
              if(this.price > 0) {
                margin = Math.round(((this.price - this.cost) / this.price) * 100).toFixed(2);
              }
                return margin + '%';
            },
            filtered_breakdown(){
                if(this.canHaveBreakdown) {
                    return this.breakdown.filter((row)=>{
                        if(this.fabricator_id === 13 && !this.isProcessor) {
                            return row.name === 'surcharge';
                        } else {
                            if(this.fabricator_id === 8 && row.name === 'type') {
                                return false;
                            }
                            return row.price != 0 || (row.fabricator_list_price && (row.fabricator_list_price.value != 0)) || (row.cost != 0 && this.inScope('cost-prices'));
                        }
                    });
                }
            },
            has_sales_codes(){
                return this.filtered_breakdown.find((row) => {
                    if(!row.fabricator_list_price){
                        return false;
                    }
                    return row.fabricator_list_price.sales_code !== null;
                }) !== undefined;
            },
        },
        data(){
            return {
                price: 0,
                cost: 0,
                breakdown: {},
                loading: true,
                show_breakdown: false,
                fabricator_id: null,
                hasResellerBreakdown: false,
                reseller_breakdown: {},
                current_request_count: -999999,
            }
        },
        methods: {
            show_breakdown_modal(){
                window.Swal.fire({
                    width: '100%',
                    title: 'Price Breakdown',
                    html: $('#breakdown').html(),
                    showCloseButton: true,
                })
            },
            get_friendly_name(name){
                return name.replace(new RegExp("_", "g"), ' ');
            },
            get_name_with_underscores(name) {
              return name.replace(/\./g, '_');
            },
            currency(){
                if(this.fabricator_id == 29){
                    return 'EUR';
                }
                return 'GBP';
            },
            getDescription(row) {
              let label = window.trans('summary.label.'+ this.get_name_with_underscores(row.name));
              if(label) {
                return `${label}:`;
              }
              return "";
            },
        },
        mounted() {

            window.emitter.on('price-updating', (door) => {
                this.fabricator_id = door.attr.fabricator;
                this.loading = true;
            });

            window.emitter.on('current-request-count-updated', ({ current_request_count }) => {
                this.current_request_count = current_request_count;
            });

            window.emitter.on('price-updated', ({ price, cost, breakdown, reseller_breakdown, price_broken }) => {
                this.price = price;
                this.cost = cost;
                this.reseller_breakdown = reseller_breakdown;

                if (this.reseller_breakdown != null) {
                    this.hasResellerBreakdown = true;
                }

                this.breakdown = breakdown;
                this.price_broken = price_broken;
                this.loading = false;
            });

        },
        onUnmounted() {
            window.emitter.off('price-updating');
            window.emitter.off('price-updated');
        },
    }
</script>
